"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "catignano": {
    "2333fc69": [{
      "hkey": "819b5daf",
      "slug": "cappuccini",
      "name": "Cappuccini",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-cappuccini": [{
      "hkey": "819b5daf",
      "slug": "cappuccini",
      "name": "Cappuccini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9b919138": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "skipSearch": false
    }],
    "decontra": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6601bb00": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "skipSearch": false
    }],
    "paludi": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8cb2710e": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "skipSearch": false
    }],
    "sterpara": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "effe1b17": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "skipSearch": false
    }],
    "varano": [{
      "hkey": "bb5813d6",
      "slug": "catignano",
      "name": "Catignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;